import React from 'react';
import Image from 'next/legacy/image';

import { IAvatar } from '../models/avatar';

export default function Avatar({ author }: IAvatar) {
	const authorName =
		author.node.firstName && author.node.lastName
			? `${author.node.firstName} ${author.node.lastName}`
			: author.node.name;

	return (
		<div className="flex items-center">
			<div className="w-12 h-12 relative mr-4">
				<Image
					src={author.node.avatar.url}
					layout="fill"
					className="rounded-full"
					alt={authorName}
				/>
			</div>
			<div className="text-xl font-bold">{authorName}</div>
		</div>
	);
}
